import React from 'react';

import { useLabels } from '../../i18n/useLabels';
import type { SectionViewModel } from '../../viewmodels/createSectionViewModel';
import { QuestionRow } from './QuestionRow';

import styles from './QuestionTable.scss';

type Props = {
  viewModel: Pick<SectionViewModel, 'name' | 'rows' | 'emptyMessage'>;
};

export function QuestionTable({ viewModel }: Props) {
  const labels = useLabels();

  return (
    <div role="table" aria-label={viewModel.name} className={styles.table}>
      <div role="row" className={styles.headerRow}>
        <div role="columnheader">{labels.questionsHeading}</div>
        <div role="columnheader">{labels.responseTypeHeading}</div>
      </div>
      {viewModel.rows.map(row => (
        <QuestionRow key={row.id} viewModel={row} />
      ))}
      {viewModel.emptyMessage && (
        <div role="row" className={styles.row}>
          <div role="cell" className={styles.emptyMessage}>
            {labels.formatMessage(viewModel.emptyMessage)}
          </div>
        </div>
      )}
    </div>
  );
}
